import i18n from '../VueI18n'
/**
 *
 * @param {Object} parcela Parcela que deve ser validada
 * @param {Array<Object>} parcelas Lista de parcelas que devem ser usados para validacao
 */
const validarPacela = (parcela, parcelas) => {
	if (!isUnique(parcela, parcelas)) {
		return {
			isValid: false,
			message: `${i18n.t('oCodigoDeParcela')} "${parcela.prla_cd_codigo}" ${i18n.t('utilizeUmCodigoDiferenteParcela')}`,
		}
	}
	return { isValid: true }
}

/**
 * Valida se a espécie possui valores unicos considerando:
 * - prla_cd_codigo
 * - fk_ptio_plantio
 * @param {Object}  Parcela que deve ser validado
 * @param {Array<Object>} parcelas Lista de parcelas que devem ser usados para validacao
 */
function isUnique(parcela, parcelas) {
	return (
		parcelas
			.filter((parcelaDaLista) => parcelaDaLista.fk_ptio_plantio === parcela.fk_ptio_plantio)
			.filter((parcelaDaLista) => parcelaDaLista.prla_cd_codigo === parcela.prla_cd_codigo)
			.length === 0
	)
}

export default validarPacela
